import React, { useEffect, useState } from "react";
import { Labelbox } from "..";
import {
  CUSTOM_FILED_COPIES_DOCUMENT_TAG,
  getFiledCopiesDocumentTagOptions,
} from "../../constants/filedCopiesDocumentTags";
import "./filed-copies-upload-file-list.scss";

const TAG_PLACEHOLDER = { id: "", value: "Select document tag" };

const presetTagIds = (documentCategory) =>
  getFiledCopiesDocumentTagOptions(documentCategory)
    .map((option) => option.id)
    .filter((id) => id !== CUSTOM_FILED_COPIES_DOCUMENT_TAG);

export default function FiledCopiesUploadFileList({
  files = [],
  tags = [],
  documentCategory = "individual",
  serviceOptions = [],
  selectedServiceId = "",
  onServiceChange,
  onTagChange,
  onRemoveFile,
}) {
  const tagOptions = [
    TAG_PLACEHOLDER,
    ...getFiledCopiesDocumentTagOptions(documentCategory),
  ];
  const presets = presetTagIds(documentCategory);
  const showServicePicker = Array.isArray(serviceOptions) && serviceOptions.length > 0;
  const [customMode, setCustomMode] = useState({});
  const [customTexts, setCustomTexts] = useState({});

  useEffect(() => {
    setCustomMode((prev) => {
      const next = {};
      files.forEach((_, index) => {
        const tag = String(tags[index] || "").trim();
        next[index] =
          prev[index] === true ||
          (Boolean(tag) && !presets.includes(tag));
      });
      return next;
    });
    setCustomTexts((prev) => {
      const next = {};
      files.forEach((_, index) => {
        const tag = String(tags[index] || "").trim();
        if (prev[index] != null) {
          next[index] = prev[index];
        } else if (tag && !presets.includes(tag)) {
          next[index] = tag;
        } else {
          next[index] = "";
        }
      });
      return next;
    });
    // files length / order is the source of truth when files are added or removed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files.length]);

  const handleSelectTag = (index, value) => {
    if (value === CUSTOM_FILED_COPIES_DOCUMENT_TAG) {
      setCustomMode((prev) => ({ ...prev, [index]: true }));
      onTagChange(index, String(customTexts[index] || "").trim());
      return;
    }
    setCustomMode((prev) => ({ ...prev, [index]: false }));
    setCustomTexts((prev) => ({ ...prev, [index]: "" }));
    onTagChange(index, value);
  };

  const handleCustomTagChange = (index, text) => {
    setCustomTexts((prev) => ({ ...prev, [index]: text }));
    onTagChange(index, String(text || "").trim());
  };

  if (!files.length && !showServicePicker) return null;

  return (
    <div className="individual-file-fields filed-copies-upload-file-list">
      {showServicePicker ? (
        <div className="filed-copies-service-field">
          <Labelbox
            type="select"
            labelname="Service"
            value={selectedServiceId || ""}
            dropdown={serviceOptions}
            changeData={(value) => onServiceChange?.(value)}
          />
        </div>
      ) : null}

      {files.map((file, index) => {
        const isCustom = Boolean(customMode[index]);
        const dropdownValue = isCustom
          ? CUSTOM_FILED_COPIES_DOCUMENT_TAG
          : tags[index] || "";
        return (
          <div
            key={`${file.name}-${index}`}
            className="individual-file-field filed-copies-file-field"
          >
            <div className="file-field-content">
              <span className="file-name-text">{file.name}</span>
              <button
                type="button"
                className="remove-file-icon"
                onClick={() => onRemoveFile(index)}
                aria-label="Remove file"
              >
                ✖
              </button>
            </div>
            <div className="filed-copies-tag-field">
              <Labelbox
                type="select"
                labelname="Document Tag"
                value={dropdownValue}
                dropdown={tagOptions}
                changeData={(value) => handleSelectTag(index, value)}
              />
            </div>
            {isCustom ? (
              <div className="filed-copies-tag-field">
                <Labelbox
                  type="text"
                  labelname="Custom Tag"
                  value={customTexts[index] || ""}
                  changeData={(value) => handleCustomTagChange(index, value)}
                  placeholder="Enter a custom document tag"
                />
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
